// extracted by mini-css-extract-plugin
export default {"wrapper":"Switchers_wrapper__vRFQm","switcherWrapper":"Switchers_switcherWrapper__jjFtt"};